import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router";
import {useSubscription} from "../../subscription/useSubscription";
import {ExploreSection} from "../explore/ExploreSection";
import {CompanyWithinPortfolioHeader} from "./CompanyWithinPortfolioHeader";
import ExploreNavigation from "../explore/ExploreNavigation";
import companyExploreActionsFactory from "./companyExploreActions";
import KpiChooser, {ValueChooser} from "../kpi/KpiChooser";
import OurProgrammeContext, {exploreSubscriptionUrl} from "../navigation/OurProgrammeContext";
import {CentredLoader} from "../../elements/Loader";

const CompanyWithinPortfolioExplorePage = ({}) => {
    const history = useHistory();
    const params = useParams();
    const groupingData = useSelector(state => state.companyExplore);
    useSubscription("EXPLORE_COMPANY_CUSTOM_GROUPING", exploreSubscriptionUrl(params, groupingData.filter), 60);
    const dispatch = useDispatch();
    const companyExploreActions = companyExploreActionsFactory(dispatch);
    useEffect(() => {
        return () => {
            companyExploreActions.reset();
        };
    }, []);

    if (!(groupingData && groupingData.settings && groupingData.settings.portfolioName)) {
        return <div style={{padding: 20}}><CentredLoader /></div>;
    }

    const {portfolioId, companyId} = params;
    const {settings, availablePeriods, overallGrouping, firstGroupingName, secondGroupingName} = groupingData;
    const {portfolioName, rewardPeriod} = settings;

    const loggingPayload = {
        type: "COMPANY_WITHIN_EXPLORE_PAGE_NAVIGATION",
        portfolioId,
        companyId,
        portfolioName,
        firstGroupingName,
        secondGroupingName
    };

    const kpiChooser = new KpiChooser(settings);
    const valueChooser = new ValueChooser(settings);

    const companyWithinPortfolioName = overallGrouping ? overallGrouping.groupName : "";
    const ourProgrammeContext = new OurProgrammeContext(params, portfolioName, companyWithinPortfolioName, rewardPeriod);

    const navigation = new ExploreNavigation(ourProgrammeContext);
    const navigate = navigation.onSecondaryGrouping(history);
    const onSecondaryGrouping = (secondGrouping) => {
        companyExploreActions.setLoading(true);
        navigate(secondGrouping);
    };

    return (
        <div className="t-company-with-portfolio-explore-page">
            <CompanyWithinPortfolioHeader company={groupingData}
                                          portfolioId={portfolioId}
                                          selectedKpi={kpiChooser.selectedKpi({isAdditionalGrouping: false})}
                                          periods={availablePeriods}
                                          ourProgrammeContext={ourProgrammeContext}
            />
            <ExploreSection customGrouping={groupingData}
                            kpiChooser={kpiChooser}
                            valueChooser={valueChooser}
                            canSeeAllComponents={true}
                            isLoading={groupingData.isLoading}
                            backToPortfolioPage={navigation.backToPortfolioPage(history)}
                            onSecondaryGrouping={onSecondaryGrouping}
                            totalPages={groupingData.grouping.totalPages}
                            pageNumber={groupingData.grouping.pageNumber}
                            pageNumberToUrlFunction={ourProgrammeContext.explorePagePath.bind(ourProgrammeContext)}
                            ourProgrammeContext={ourProgrammeContext}
                            loggingPayload={loggingPayload}
                            applyFilter={companyExploreActions.applyFilter}
                            pageName={"CompanyWithinPortfolioExplorePage"}
            />
        </div>
    );
};

export default CompanyWithinPortfolioExplorePage;
